(function () {
  'use strict';

  class EbMouldMakers extends HTMLElement {
    connectedCallback() {
      const target = this.querySelector('[data-mm-embed-target]');
      const tpl = this.querySelector('[data-mm-embed]');
      if (!target || !tpl) return;

      const inject = () => {
        if (target.dataset.loaded === 'true') return;
        target.dataset.loaded = 'true';
        target.innerHTML = tpl.innerHTML;
        const frame = target.querySelector('iframe');
        if (frame) {
          frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          frame.setAttribute('tabindex', '-1');
        }
      };

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              inject();
              io.disconnect();
            }
          });
        }, { rootMargin: '200px' });
        io.observe(this);
      } else {
        inject();
      }
    }
  }

  if (!customElements.get('eb-mould-makers')) {
    customElements.define('eb-mould-makers', EbMouldMakers);
  }
})();
